module.exports = __webpack_public_path__ + "img/control-s.ae9fa76e.png";